import API from "./api";
import { loadOrgProfileStatus } from "./appQueries";

export async function fetchOrgProfileStatus(options) {
  return loadOrgProfileStatus(options);
}

export async function saveOrgProfileMinimal(payload) {
  const { data } = await API.post("/setup/org-profile", payload);
  return data;
}

export async function skipOrgProfileWizard() {
  const { data } = await API.post("/setup/org-profile/skip");
  return data;
}

const MINIMUM_FIELDS = ["name", "legal_name", "pan", "tan_number", "state", "address"];

/** True only when the organisation page has no saved details. */
export function isOrgProfileEmpty(status) {
  if (typeof status?.profile_empty === "boolean") return status.profile_empty;
  const org = status?.org || {};
  return !MINIMUM_FIELDS.some((key) => String(org[key] || "").trim());
}

export function isAdminRole(role) {
  const r = String(role || "").toLowerCase();
  return r === "admin" || r === "superadmin" || r === "super_admin";
}
